import React, { useEffect, useRef, useContext } from "react";
import { AppContext } from "../../stores/application.store";
import "./VideoVR.scss";
// import VignetteVideo from "react-vignette/dist/VignetteVideo";


export default function VideoVR() {
  let { scroll } = useContext(AppContext)
  const videoContainer = useRef(null);
  // const videoContainer= document.querySelector(".videoContainer")

  // useEffect(() => {
  //   // try {
  //   //   window.YitVideo.InfrastructureInitialize();
  //   // } catch (er) {
  //   // }
  //   // alert(window.innerHeight);
  // }, []);
  useEffect(() => {
    if (!videoContainer) return;
    let target = videoContainer.current;
    let video = target.querySelector("video");
    if (!video) return;
    video.pause();
    video.currentTime = 0;
    // try {
    //   initialize()
    // } catch (er) {
    // }
  }, [scroll]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     let video = document.querySelector(".video-js")
  //     console.log("video js " , video)
  //     video.addEventListener("click" , () => {
  //       if(video.classList.contains("vjs-playing")){
  //         console.log("@@@@@@@@@@@@")
  //         document.querySelector(".video_text_wrapper").style.display = "none"
  //         document.querySelector(".video-title").style.display = "none"
  //       }
  //     })
  //   },2000)
  // },[])

  const initialize = () => {
    if (!videoContainer) return;
    let target = videoContainer.current;
    let video = target.querySelector("video");
    if (!video) return;
    video.pause();
    video.currentTime = 0;

    // try {
    //   // window.YitVideo.InfrastructureReInitialize();
    // } catch (e) {
    //   // try {
    //   //   window.YitVideo.InfrastructureInitialize();
    //   // } catch (ee) { 

    //   // }
    // }
  }

  useEffect(() => {
    if (scroll != 1) return;
    if (videoContainer.current.querySelector("video")) return;
    window.YitVideo.Constructor({
      containerAttrPrefix: "yitvideo",
      dynamicPlayerType: false, // youtube == true
      flaotOnScroll: false, // minimize the video
      popularity: true,
      siteName: "ynet",
      dcPath: "",
      nextVideo: false,
      autoEvents: true,
      adTagUrl: "https://pubads.g.doubleclick.net/gampad/live/ads?iu=/6870/ynet/video_desktop/live&description_url=https%3A%2F%2Fwww.ynet.co.il%2Fhome%2F0%2C7340%2CL-8%2C00.html&tfcd=0&npa=0&sz=480x360%7C480x361%7C640x360%7C640x480&cust_params=Autoplay%3DTrue%26VideoPosition%3DPreroll&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=",
      eventsCallback: function (event, data) {
        switch (event) {
          case 'ready':
            console.log(event, data);
            break;
          case 'firstplay':
            window.document.querySelector(".video_text_wrapper").style.display = "none"
            window.document.querySelector(".video-title").style.display = "none"
            console.log(event, data);
            break;
          case 'play':
            window.document.querySelector(".video_text_wrapper").style.display = "none"
            window.document.querySelector(".video-title").style.display = "none"
            console.log(event, data);
            break;
          case 'pause':
            // document.querySelector(".video-title").style.display = "block"
            // document.querySelector(".video_text_wrapper").style.display = "flex"
            console.log(event, data);
            break;
          case 'progress':
            console.log(event, data);
            break;
          case 'contentplay':
            console.log(event, data);
            break;
          case 'ended':
            console.log(event, data);
            break;
          case 'ads-ad-started':
            console.log(event, data);
            break;
        }
      },
    });
  }, [scroll])

  return (
    // <Div100vh>
    <section id="video_section" className="video_vr watch sec-2">
      <div className="video_title"></div>
      <div
        yitvideo="457771"
        title="Ynet VR"
        ads="1"
        ref={videoContainer}
      ></div>
      {/* <VignetteVideo videoId="457771" className="videoContainer"/> */}
      <div className="sw_title video-title">
        <div className="suitcase"></div>
        <div className="title_text">מה שכדאי לראות</div>
      </div>
      <div className="video_text_wrapper">
        <div className="video_upper_text">
          <div className="">זה לא באמת פרומו, אבל זו גם לא באמת המציאות.</div>
          <div>נתנו לאנשים לנסות VR בפעם הראשונה</div>
        </div>
        <div className="video_down_text">
          <div>תוכן: הגר בוחבוט, בימוי: אסף קוזין,</div>
          <div>עריכה: גיא פוקס, צילום: ירון שרון,</div>
          <div> הפקה והשתתפות: מיכאלה חזני, גל פרייליך</div>
        </div>
      </div>
    </section>
    // </Div100vh>
  );
}
